export default {
  mobilePay: 'MobilePay',
  points: 'Point',
  connectedPayments: 'Connected payments',
  productSubscription: 'Subscription',
  stripe: 'Stripe',
  stripeInvoice: 'Stripe',
  free: 'Free'
}